// export const locationHost = process.env.NODE_ENV === 'production' ? "https://www.mkji.cn/" : 'http://localhost:8080';
// export const apiBaseUrl = 'https://b2c.jihainet.com/';
// export const apiBaseUrl = 'http://n.haibaoguoji.com/';
export const locationHost = "https://www.mkji.cn/";
export const apiBaseUrl = 'https://api.mkji.cn/';

